import interpolate from '#/lib/interpolate.js';

export { rewireConfig };
/**
 * @typedef {object} VideoConfig.EmojiConfig
 * @property {boolean} enabled
 * @property {string} [publish]
 * @property {string} [subscribe]
 * @property {string} [history]
 * @property {{name: string, url: string}[]} [icons]
 */

/**
 * @typedef {object} VideoConfig.LogConfig
 * @property {number} level
 * @property {string} subscribe
 */

/**
 * @typedef {object} VideoConfig.PollConfig
 * @property {boolean} enable
 *
 */

/**
 * @typedef {object} VideoConfig
 * @property {string} subscribe @deprecated topic pattern for subscribe to events
 * @property {string} content_request topic pattern for publish interactive content request
 * @property {string} history url pattern for get events history
 * @property {EmojiConfig} emoji
 * @property {PollConfig} poll
 * @property {Object} promo-landing
 * @property {Object} log
 *
 * @example {
  "subscribe": "/v1/video/{{video_id}}/events",
  "history": "/v1/videos/{{video_id}}/events?from={{start_ts}}&to={{end_ts}}",
  "log": {"level": 4, "subscribe": "/v1/video/{{video_id}}/log"},
  "emoji": {
    "enabled": true,
    "publish": "/v1/video/{{video_id}}/emoji",
    "subscribe": "/v2/video/{{video_id}}/emoji/result",
    "history": "/v1/videos/{{video_id}}/emojis?from={{start_ts}}&to={{end_ts}}",
    "icons": [
      {
        "name": "hearth",
        "url": "https://s4.vcdn.biz/static/90830181/hearth.json"
      },
      {
        "name": "lol",
        "url": "https://s7.vcdn.biz/static/90830211/lol2.json"
      },
      {
        "name": "wow",
        "url": "https://s3.vcdn.biz/static/90830801/wow2.json"
      },
      {
        "name": "cry",
        "url": "https://s7.vcdn.biz/static/90831201/cry2.json"
      },
      {
        "name": "angry",
        "url": "https://s1.vcdn.biz/static/90831771/angry3.json"
      }
    ]
  },
  "poll": {
    "enabled": false
  }
}
 */

/**
 * Update received config. Apply necessary replacements to make it ready to consume.
 * @param {VideoConfig} config Interactive configuration for current object.
 * @param {{video_id: string, channel_id: string|null, root_id: string|null}} ctx Current video object's description, required to create correct replacement context.
 * @return {VideoConfig}
 */
function rewireConfig(config, ctx) {
  const replaceCtx = {
    ...ctx,
    // I don't want to see that ugly start|end_ts naming anymore.
    start_ts: '{{from}}',
    end_ts: '{{to}}',
  };
  const hasChannelId = Boolean(ctx.channel_id);
  if (hasChannelId) {
    // if (ctx.content_type === 'm_ch_vod'){
    // TODO(kyr): MHP-1730 - ASAP replace this ad-hoc fix for m_ch_vod, tv_dvr, etc.
    // console.debug('apply channel_id instead video_id');
    replaceCtx.video_id = replaceCtx.channel_id;
  }

/*
  config.content_request = interpolate(
    config.content_request ?? '/v1/video/{{video_id}}/content_request',
    replaceCtx,
  );
*/
  config.subscribe = interpolate(config.subscribe, replaceCtx);
  config.history = interpolate(config.history, replaceCtx);

  if (config.emoji.enabled) {
    config.emoji.history = interpolate(config.emoji.history, replaceCtx);
    config.emoji.publish = interpolate(config.emoji.publish, replaceCtx);
    config.emoji.subscribe = interpolate(config.emoji.subscribe, replaceCtx);
  }

  config.log ??= {};
  config.log.subscribe = interpolate(config.log.subscribe, replaceCtx);

  return config;
}
